import {
  ComponentDefaultFilterKeys,
  ReferenceDefaultFilterKeys,
} from './filterEnums';
import type { FilterAttribute } from './filterInterface';

export const COMPONENT_FILTER_ATTRIBUTE_LABELS: FilterAttribute[] = [
  {
    name: ComponentDefaultFilterKeys.NAME,
    label: 'Name',
  },
  {
    name: ComponentDefaultFilterKeys.DESCRIPTION,
    label: 'Description',
  },
  {
    name: ComponentDefaultFilterKeys.TYPE,
    label: 'Type',
  },
  {
    name: ComponentDefaultFilterKeys.ID,
    label: 'ID',
  },
  {
    name: ComponentDefaultFilterKeys.PARENT,
    label: 'Children of',
  },
  {
    name: ComponentDefaultFilterKeys.VERSION,
    label: 'Revision',
  },
  {
    name: ComponentDefaultFilterKeys.CREATED,
    label: 'Created',
  },
  {
    name: ComponentDefaultFilterKeys.LAST_UPDATED,
    label: 'Last updated',
  },
  {
    name: ComponentDefaultFilterKeys.INCOMING_REF_COUNT,
    label: 'Incoming references',
  },
  {
    name: ComponentDefaultFilterKeys.OUTGOING_REF_COUNT,
    label: 'Outgoing references',
  },
];

export const REFERENCE_FILTER_ATTRIBUTE_LABELS: FilterAttribute[] = [
  {
    name: ReferenceDefaultFilterKeys.DISPLAY_TEXT,
    label: 'Display text',
  },
  {
    name: ReferenceDefaultFilterKeys.DESCRIPTION,
    label: 'Description',
  },
  {
    name: ReferenceDefaultFilterKeys.TYPE,
    label: 'Type',
  },
  {
    name: ReferenceDefaultFilterKeys.ID,
    label: 'ID',
  },
  {
    name: ReferenceDefaultFilterKeys.CREATED,
    label: 'Created',
  },
  {
    name: ReferenceDefaultFilterKeys.LAST_UPDATED,
    label: 'Last updated',
  },
  {
    name: ReferenceDefaultFilterKeys.TARGET,
    label: 'Reference to',
  },
  {
    name: ReferenceDefaultFilterKeys.SOURCE,
    label: 'Reference from',
  },
  {
    name: ReferenceDefaultFilterKeys.TARGET_WORKSPACE,
    label: 'Show references to workspace',
  },
  {
    name: ReferenceDefaultFilterKeys.ROOT_WORKSPACE,
    label: 'Show references from workspace',
  },
];

export const systemAttributeLabelMap: Map<string, string> = new Map(
  [
    ...COMPONENT_FILTER_ATTRIBUTE_LABELS,
    ...REFERENCE_FILTER_ATTRIBUTE_LABELS,
  ].map(attr => [attr.name, attr.label])
);
